import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { IEncounterData } from "../../../utils/interfaces";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";

export async function PostEncounter(objData: IEncounterData) {
  let url = `${endpoints.EHRPOSTER}/Encounter`;

  const data = auxiliarData.Encounter(objData);
  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PostEncounter: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostEncounter ", error);
      // toast.error(`PostEncounter Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
